import { projectClient } from '../../client/client';

export const user = {
  list: projectClient('/user').get,
  get: projectClient('/user/{id}').get,
  delete: projectClient('/user/{id}').delete,
  update: projectClient('/user/{id}').patch,
  invite: projectClient('/user/invite').post,
  me: projectClient('/user/me').get,
  listV2: projectClient('/user/v2/list').get,
};
